import { render } from "./label_setting.vue?vue&type=template&id=310c2f06&scoped=true"
import script from "./label_setting.vue?vue&type=script&lang=js"
export * from "./label_setting.vue?vue&type=script&lang=js"

import "./label_setting.vue?vue&type=style&index=0&id=310c2f06&scoped=true&lang=css"
import "./label_setting.vue?vue&type=style&index=1&id=310c2f06&lang=css"
import "./label_setting.vue?vue&type=style&index=2&id=310c2f06&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310c2f06"]])

export default __exports__